import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "cover" }
const _hoisted_2 = { class: "dialog__body" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dialog", _ctx.action])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.dialog.title), 1),
        (_ctx.dialog.tip)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "tips",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTip && _ctx.handleTip(...args)))
            }, [
              (_ctx.hasCheck)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(`qh-icon-${_ctx.deleteCompletely ? 'checked' : 'check'}`)
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.dialog.tip), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.action === 'tip-guide')
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(["remind-img", {'ios': _ctx.isIOS }])
            }, null, 2))
          : _createCommentVNode("", true),
        (_ctx.dialog.more)
          ? (_openBlock(), _createElementBlock("p", {
              key: 2,
              innerHTML: _ctx.dialog.more
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.dialog.verticalFooter ? 'dialog__vertical' : 'dialog__footer')
      }, [
        _withDirectives(_createElementVNode("a", {
          href: "javascript:;",
          class: "button-other",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close('cancel')))
        }, _toDisplayString(_ctx.dialog.cancelTxt), 513), [
          [_vShow, _ctx.dialog.cancelTxt]
        ]),
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAcion && _ctx.handleAcion(...args)))
        }, [
          _createVNode(_component_Loader, {
            modelValue: _ctx.showLoader,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showLoader) = $event)),
            action: _ctx.action,
            "inner-text": _ctx.showLoader ? _ctx.dialog.loadingTxt : _ctx.dialog.okTxt
          }, null, 8, ["modelValue", "action", "inner-text"])
        ]),
        (_ctx.dialog.verticalFooter)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:;",
              class: "button-other",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close('close')))
            }, "取消"))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ]))
}